import { ResourcesConfig } from 'aws-amplify';

import { TAmplifyConfigurationProps } from '@/shared/aws-export.types';

export const amplifyConfiguration = ({
  userPoolId,
  userPoolClientId,
}: TAmplifyConfigurationProps): ResourcesConfig => {
  return {
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        identityPoolId: import.meta.env.VITE_APP_AWS_COGNITO_IDENTITY_POOL_ID,
        loginWith: {
          oauth: {
            domain: import.meta.env.VITE_APP_AWS_COGNITO_URL?.replace(
              'https://',
              '',
            ),
            scopes: [
              'phone',
              'email',
              'openid',
              'profile',
              'aws.cognito.signin.user.admin',
            ],
            redirectSignIn: [window.location.origin],
            redirectSignOut: [window.location.origin],
            responseType: 'code',
          },
        },
      },
    },
    API: {
      Events: {
        endpoint: `https://${import.meta.env.VITE_APP_APPSYNC_ENDPOINT}/event`,
        region: import.meta.env.VITE_APP_AWS_PROJECT_REGION,
        defaultAuthMode: 'userPool',
      },
    },
  };
};
